import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import './Card.scss';

export default class Card extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { selected: false };
  }

  handleClick(e) {
    if (!this.dragging) {
      const { handleCardSelected } = this.props;
      if (handleCardSelected) {
        handleCardSelected(this.props.selected ? false : true);
      }
    }
  }

  render() {
    const{ left, top, width, height, contents, selected, childSelected } = this.props;
    const style = { left: left + 'px', top: top + 'px', width: width + 'px', height: height + 'px' };
    const classNames = 'card-container ' + (childSelected ? ' child-selected' : (selected ? ' selected' : ''));
    return (
      <div id={this.props.id} className={classNames} style={style}
        onClick={this.handleClick}>
        {contents}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/index.js